import { LocationInterface, LocationUpdateParamsInterface } from 'interfaces/location.interface';
import { ReviewQueryParams } from 'modules/review/review-query-params.enum';

export const updateLocation = (currentLocation: LocationInterface, params: LocationUpdateParamsInterface): LocationInterface => {
    const newLocation = {
        ...currentLocation
    };

    if (params.path) {
        newLocation.path = params.path;
    }

    if (typeof params.query === 'object') {
        newLocation.query = {
            [ReviewQueryParams.type]: newLocation.query[ReviewQueryParams.type] || null, // needed for required order of params
            [ReviewQueryParams.rating]: newLocation.query[ReviewQueryParams.rating] || null, // needed for required order of params
            [ReviewQueryParams.sorting]: newLocation.query[ReviewQueryParams.sorting] || null, // needed for required order of params
            [ReviewQueryParams.pagination]: newLocation.query[ReviewQueryParams.pagination] || null, // needed for required order of params
            ...newLocation.query,
            ...params.query
        };

        if (newLocation.query[ReviewQueryParams.type] === 'firmowe') {
            newLocation.query[ReviewQueryParams.type] = null;
        }

        newLocation.query = Object.keys(newLocation.query)
            .reduce(
                (partialQuery: Record<string, string | number | null>, key) => {
                    if (newLocation.query[key] !== null) {
                        partialQuery[key] = newLocation.query[key];
                    }

                    return partialQuery;
                },
                {}
            );
    }

    newLocation.url = [
        newLocation.path,
        Object.keys(newLocation.query)
            .map(key => `${key}=${encodeURIComponent(newLocation.query[key] as string | number).replace('%2C', ',')}`)
            .join('&')
    ].join('?');

    return newLocation;
};
